import serviceRequest from "utils/request";

const baseUrl = "/api/userDrag";

export const getUserDrag = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-user-drag`,
		method: "get",
		params,
	});
};

export const updateUserDrag = (params) => {
	return serviceRequest({
		url: `${baseUrl}/update-user-drag`,
		method: "get",
		params,
	});
};
